import { Controller } from 'stimulus';

export default class extends Controller {
  //nicked this from https://www.jorgemanrubia.com/2019/02/16/form-validations-with-html5-and-modern-rails/
  //https://github.com/jorgemanrubia/rails-form-validations-example/blob/master/app/javascript/controllers/form_controller.js
  static targets = [
    'form',
    'profileImageControls',
    'profileImageFileInput',
    'profileImagePlaceholder',
    'profileImagePositionXInput',
    'profileImagePositionXSlider',
    'profileImagePositionXValue',
    'profileImagePositionYInput',
    'profileImagePositionYSlider',
    'profileImagePositionYValue',
    'profileImagePreview',
    'profileImagePreviewFrame',
    'profileImageScaleInput',
    'profileImageScaleSlider',
    'profileImageScaleValue',
    'profileImageSourceHeightInput',
    'profileImageSourceWidthInput',
    'profileImageZoomInput',
    'profileImageZoomSlider',
    'profileImageZoomValue'
  ];

  connect() {
    this.element.setAttribute('novalidate', true)
    this.element.addEventListener('blur', this.onBlur, true)
    this.element.addEventListener('keyup', this.onBlur, true)
    this.element.addEventListener('submit', this.onSubmit)
    this.element.addEventListener('ajax:beforeSend', this.onSubmit)
    this.initializeProfileImageEditor()
  }

  disconnect () {
    this.element.removeEventListener('blur', this.onBlur)
    this.element.removeEventListener('keyup', this.onBlur)
    this.element.removeEventListener('submit', this.onSubmit)
    this.element.removeEventListener('ajax:beforeSend', this.onSubmit)
  }

  onBlur = (event) => {
    this.validateField(event.target)
  }

  onSubmit = (event) => {
    if (!this.validateForm()) {
      event.preventDefault()
      this.firstInvalidField.focus()
    }
  }

  validateForm () {
    let isValid = true
    // Not using `find` because we want to validate all the fields
    this.formFields.forEach((field) => {
      if (this.shouldValidateField(field) && !this.validateField(field)) isValid = false
    })
    return isValid
  }

  validateField (field) {
    if (!this.shouldValidateField(field))
      return true
    const isValid = field.checkValidity()
    field.classList.toggle("is-invalid", !isValid);
    this.refreshErrorForInvalidField(field, isValid)
    return isValid
  }

  shouldValidateField (field) {
    if (field.type === undefined ){
      return false
    }
    return !field.disabled && !['file', 'reset', 'submit', 'button'].includes(field.type)
  }

  refreshErrorForInvalidField (field, isValid) {
    this.removeExistingErrorMessage(field)
    if (!isValid)
      this.showErrorForInvalidField(field)
  }

  removeExistingErrorMessage (field) {
    const fieldContainer = field.closest('.field')
    if(!fieldContainer)
      return;

    const existingErrorMessageElement = fieldContainer.querySelector('.error')

    if (existingErrorMessageElement)
      existingErrorMessageElement.parentNode.removeChild(existingErrorMessageElement)
  }

  showErrorForInvalidField (field) {
    //skipping filling up the form with text until it fails server side validation
    //field.insertAdjacentHTML('afterend', this.buildFieldErrorHtml(field))
  }

  // buildFieldErrorHtml (field) {
  //   return `<span class="error">${field.validationMessage}</span>`
  // }

  get formFields () {
    return Array.from(this.element.elements)
  }

  get firstInvalidField () {
    return this.formFields.find(field => !field.checkValidity())
  }

  initializeProfileImageEditor() {
    if (!this.hasProfileImagePreviewTarget) return

    this.originalProfileImageSrc = this.profileImagePreviewTarget.dataset.originalSrc || this.profileImagePreviewTarget.getAttribute("src") || ""
    this.updateProfileImageCrop()
    this.refreshProfileImageEditorVisibility()
  }

  loadProfileImagePreview(event) {
    const [file] = event.target.files

    if (!file) {
      this.profileImagePreviewTarget.src = this.originalProfileImageSrc
      this.profileImagePreviewTarget.dataset.naturalWidth = this.profileImagePreviewTarget.dataset.originalNaturalWidth || ""
      this.profileImagePreviewTarget.dataset.naturalHeight = this.profileImagePreviewTarget.dataset.originalNaturalHeight || ""
      this.refreshProfileImageEditorVisibility()
      this.updateProfileImageCrop()
      return
    }

    const reader = new FileReader()
    reader.onload = ({ target }) => {
      this.profileImagePreviewTarget.src = target.result
      delete this.profileImagePreviewTarget.dataset.naturalWidth
      delete this.profileImagePreviewTarget.dataset.naturalHeight
      this.refreshProfileImageEditorVisibility()
      this.updateProfileImageCrop()
    }
    reader.readAsDataURL(file)
  }

  updateProfileImageCrop() {
    if (!this.hasProfileImagePreviewTarget || !this.hasProfileImageZoomSliderTarget) return

    const scale = this.hasProfileImageScaleSliderTarget ? Number(this.profileImageScaleSliderTarget.value || 1) : 1
    const zoom = Number(this.profileImageZoomSliderTarget.value || 1)
    const positionX = Number(this.profileImagePositionXSliderTarget.value || 50)
    const positionY = Number(this.profileImagePositionYSliderTarget.value || 50)
    const storedNaturalWidth = Number(this.profileImagePreviewTarget.dataset.naturalWidth || 0)
    const storedNaturalHeight = Number(this.profileImagePreviewTarget.dataset.naturalHeight || 0)
    const loadedNaturalWidth = Number(this.profileImagePreviewTarget.naturalWidth || 0)
    const loadedNaturalHeight = Number(this.profileImagePreviewTarget.naturalHeight || 0)
    const naturalWidth = storedNaturalWidth > 0 ? storedNaturalWidth : (loadedNaturalWidth > 0 ? loadedNaturalWidth : 1)
    const naturalHeight = storedNaturalHeight > 0 ? storedNaturalHeight : (loadedNaturalHeight > 0 ? loadedNaturalHeight : 1)

    if (this.hasProfileImageSourceWidthInputTarget) {
      this.profileImageSourceWidthInputTarget.value = Math.round(naturalWidth)
    }
    if (this.hasProfileImageSourceHeightInputTarget) {
      this.profileImageSourceHeightInputTarget.value = Math.round(naturalHeight)
    }

    if (this.hasProfileImageScaleInputTarget) {
      this.profileImageScaleInputTarget.value = scale
    }
    if (this.hasProfileImageZoomInputTarget) {
      this.profileImageZoomInputTarget.value = zoom
    }
    if (this.hasProfileImagePositionXInputTarget) {
      this.profileImagePositionXInputTarget.value = positionX
    }
    if (this.hasProfileImagePositionYInputTarget) {
      this.profileImagePositionYInputTarget.value = positionY
    }

    if (this.hasProfileImagePreviewFrameTarget) {
      const frameSize = Number(this.profileImagePreviewFrameTarget.dataset.baseSize || 220)
      this.profileImagePreviewFrameTarget.style.width = `${frameSize}px`
      this.profileImagePreviewFrameTarget.style.minWidth = `${frameSize}px`
      this.profileImagePreviewFrameTarget.style.height = `${frameSize}px`
    }

    const fitRatio = Math.min(1 / naturalWidth, 1 / naturalHeight)
    const widthRatio = naturalWidth * fitRatio * scale * zoom
    const heightRatio = naturalHeight * fitRatio * scale * zoom
    const leftPercent = (1 - widthRatio) * positionX
    const topPercent = (1 - heightRatio) * positionY

    this.profileImagePreviewTarget.style.width = `${widthRatio * 100}%`
    this.profileImagePreviewTarget.style.height = `${heightRatio * 100}%`
    this.profileImagePreviewTarget.style.left = `${leftPercent}%`
    this.profileImagePreviewTarget.style.top = `${topPercent}%`
    this.profileImagePreviewTarget.style.transform = "none"

    if (this.hasProfileImageScaleValueTarget) {
      this.profileImageScaleValueTarget.textContent = `${scale.toFixed(2)}x`
    }
    if (this.hasProfileImageZoomValueTarget) {
      this.profileImageZoomValueTarget.textContent = `${zoom.toFixed(2)}x`
    }
    if (this.hasProfileImagePositionXValueTarget) {
      this.profileImagePositionXValueTarget.textContent = `${Math.round(positionX)}%`
    }
    if (this.hasProfileImagePositionYValueTarget) {
      this.profileImagePositionYValueTarget.textContent = `${Math.round(positionY)}%`
    }
  }

  resetProfileImageCrop(event) {
    event.preventDefault()
    if (!this.hasProfileImageZoomSliderTarget) return

    if (this.hasProfileImageScaleSliderTarget) {
      this.profileImageScaleSliderTarget.value = 1
    }
    this.profileImageZoomSliderTarget.value = 1
    this.profileImagePositionXSliderTarget.value = 50
    this.profileImagePositionYSliderTarget.value = 50
    this.updateProfileImageCrop()
  }

  refreshProfileImageEditorVisibility() {
    if (!this.hasProfileImagePreviewTarget) return

    const hasImage = Boolean(this.profileImagePreviewTarget.getAttribute("src"))
    this.profileImagePreviewTarget.style.display = hasImage ? "block" : "none"

    if (this.hasProfileImagePlaceholderTarget) {
      this.profileImagePlaceholderTarget.classList.toggle("d-none", hasImage)
    }

    if (this.hasProfileImageControlsTarget) {
      this.profileImageControlsTarget.classList.toggle("d-none", !hasImage)
    }
  }
}
